module.exports = __webpack_public_path__ + "static/media/chat04.6d9f784b.png";